// src/lib/errors/AppError.ts

export interface ApiErrorProps {
  message: string;
  code: string;
  errKey: string;
  friendlyMessage: string;
}

export class ApiError extends Error {
  public readonly code: string;
  public readonly errKey: string;
  public readonly friendlyMessage: string;

  constructor({ message, code, errKey, friendlyMessage }: ApiErrorProps) {
    super(message);

    // Set the prototype explicitly (important when targeting ES5/ES2015)
    Object.setPrototypeOf(this, new.target.prototype);

    this.name = 'AppError';
    this.code = code;
    this.errKey = errKey;
    this.friendlyMessage = friendlyMessage;

    // Optional: cleaner stack trace
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }
  }

  toJSON() {
    return {
      name: this.name,
      message: this.message,
      code: this.code,
      errKey: this.errKey,
      friendlyMessage: this.friendlyMessage,
    };
  }
}

export function formatErrorMessage(error: unknown, defaultMessage: string): string {
  return error instanceof ApiError
    ? (error?.friendlyMessage ?? defaultMessage)
    : defaultMessage;
}
